import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/layouts/default.vue")),
  login: defineAsyncComponent(() => import("/var/www/vhosts/GESTIONALI/bt-studio-generatore-documenti/layouts/login.vue"))
}